import { RowClassRules } from 'ag-grid-community';

import { IContact } from 'contacts/types';

export const isDeletedContactRow = ({ data }: { data?: Pick<IContact, 'deleted'> }) =>
  !!data?.deleted;

// Must stay `rowClassRules`, not `getRowClass`: AG-Grid re-runs both when a row's data changes,
// but the getRowClass path only ever ADDS the classes it returns and never removes the ones it
// stopped returning, so a restored contact kept its strikeout until a full page reload.
export const contactRowClassRules: RowClassRules<IContact> = {
  'deletedRow disabledRow': isDeletedContactRow,
};
